import { render, staticRenderFns } from "./Stallions.vue?vue&type=template&id=7d944b66&"
import script from "./Stallions.vue?vue&type=script&lang=js&"
export * from "./Stallions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports